
<app-mwe-table [columns]="columns" [data]="unitOfMeasureData" [title]="'Unit of Measure'" [showAddButton]="hasAddPermission" [showSearch]="true" (selectedAction)="selectedAction($event)" 
(searchTerm)="onSearchKeyword($event)" [initialSearchValue]="searchKeyword" [showPagination]="showPagination"
[totalEntries]="totalEntries"></app-mwe-table>
<div *ngIf="showNoRecordsFounds && searchKeyword === ''"  class="no-results">
    <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
    <div class="no-records-found"> No Records Found </div>
  </div>





  